import React, { useState } from 'react';
import { X, Download, Loader } from 'lucide-react';
import { downloadMedia } from '../utils/downloadMedia';
import './ImageModal.css';

// Вспомогательная функция для определения типа медиа
const isVideoFile = (url) => {
  if (!url || typeof url !== 'string') return false;
  const urlLower = url.toLowerCase();
  if (urlLower.startsWith('data:video/')) return true;
  if (urlLower.startsWith('blob:')) return false;
  return urlLower.includes('.mp4') || urlLower.includes('.mov') || urlLower.includes('.webm') || urlLower.includes('.gif') || urlLower.includes('.m4v') || urlLower.includes('.qt') || urlLower.includes('video/quicktime');
};

const modalVideoMime = (url) => {
  const lower = String(url || '').toLowerCase();
  if (lower.startsWith('blob:') || lower.startsWith('data:')) return null;
  if (lower.includes('.webm')) return 'video/webm';
  return 'video/mp4';
};

const isAudioFile = (url) => {
  if (!url) return false;
  const path = String(url).toLowerCase().split('?')[0];
  return ['.mp3', '.wav', '.m4a', '.ogg', '.aac', '.flac'].some((ext) => path.endsWith(ext));
};

function ImageModal({ imageUrl, onClose }) {
  const [isDownloading, setIsDownloading] = useState(false);
  
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleKeyDown = React.useCallback((e) => {
    if (e.key === 'Escape') {
      onClose();
    }
  }, [onClose]);

  React.useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [handleKeyDown]);

  const downloadFile = (url) => {
    downloadMedia(url, {
      toastId: 'download-modal',
      onLoadingChange: setIsDownloading,
    });
  };

  if (!imageUrl) return null;

  const url = typeof imageUrl === 'object' && imageUrl !== null && imageUrl.url != null
    ? imageUrl.url
    : imageUrl;
  const isVideo = typeof imageUrl === 'object' && imageUrl !== null && imageUrl.isVideo === true
    ? true
    : isVideoFile(url);
  const isAudio = isAudioFile(url);

  return (
    <div className="image-modal-fullscreen" onClick={handleBackdropClick}>
      <button className="modal-close-btn" onClick={onClose}>
        <X size={24} />
      </button>
      <button 
        className="modal-download-btn" 
        onClick={(e) => {
          e.stopPropagation();
          downloadFile(url);
        }}
        title="Скачать"
        disabled={isDownloading}
      >
        {isDownloading ? (
          <Loader size={20} className="spinning" />
        ) : (
          <Download size={20} />
        )}
      </button>
      <div className="modal-image-container">
        {isAudio ? (
          <audio src={url} controls autoPlay style={{ width: 'min(520px, 90vw)' }} />
        ) : isVideo ? (
          <video
            key={url}
            src={modalVideoMime(url) ? undefined : url}
            controls
            autoPlay
            playsInline
            style={{
              maxWidth: '100%',
              maxHeight: '90vh',
              width: 'auto',
              height: 'auto',
              objectFit: 'contain'
            }}
          >
            {modalVideoMime(url) ? <source src={url} type={modalVideoMime(url)} /> : null}
          </video>
        ) : (
          <img src={url} alt="Full size preview" />
        )}
      </div>
    </div>
  );
}

export default ImageModal;
